import React from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      {/*
        Shares the checkout container's width and inset (see maxWidth.shell in
        tailwind.config.js) so the logo aligns with the section headings below it. This was
        max-w-7xl with lg:px-8, which put the logo 32px outside the container edge.
      */}
      <div className="mx-auto max-w-shell px-4 sm:px-7">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img
                src="/img/logo.svg"
                alt="Decisive Sites"
                className="h-8 w-auto"
              />
            </Link>
          </div>
          {/*
            External links must use a plain <a>, not react-router's <Link>. <Link to>
            builds an app-relative href, so an absolute URL became /https://... and 404'd.
          */}
          {/*
            `-mr-3` cancels the last link's own `px-3` so the NAV TEXT ends flush with the
            container inset, level with the logo on the other side.

            Without it the boxes line up but the text does not: each anchor pads itself by 12px,
            so "Need Help?" stopped 40px from the container edge while the logo started at 28px.
            A 12px asymmetry is small enough to look like a mistake rather than a margin, which
            is exactly how it read. The padding stays -- it is the links' click target.
          */}
          <nav className="-mr-3 hidden md:flex space-x-8">
            <a
              href="https://decisivesites.com/plans-pricing/"
              rel="noopener"
              className="text-gray-500 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              Plans and Pricing
            </a>
            <a
              href="https://decisivesites.com/support/"
              rel="noopener"
              className="text-gray-500 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              Need Help?
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}
